import * as axios from 'axios';
import router from '@/router';
import store from '@/store';

const baseURL = `${process.env.VUE_APP_API_URL}`;

const Repository = axios.create({
  baseURL,
  withCredentials: true,
});

Repository.interceptors.request.use(
  (config) => {
    return config;
  },

  (error) => {
    return Promise.reject(error);
  }
);

Repository.interceptors.response.use(
  (response) => {
    return response.data;
  },

  (error) => {
    if (error.response && error.response.status === 401) {
      store.dispatch('auth/logout').finally(() => {
        router.push('login');
      });
    }
    return error?.response?.data ? Promise.reject(error.response.data) : Promise.reject(error);
  }
);

export default Repository;
